import { makeStyles } from '@material-ui/core/styles';

import appTheme from 'styles/themes/app';

export const useStyles = makeStyles(() => ({
  customToolbar: {
    fontSize: 22,
    fontWeight: 600,
    lineHeight: '26.4px',
    paddingLeft: 6,
    color: appTheme.palette.primary.main,
  },
}));
